import { computeJobDetails } from "./utils";
import { mergeActiveEstimateSnapshot } from "./invoiceTaskUtils";
import { JAB_ORG_ID } from "./jabJobDetails";

// Inline editing of the public job details (Description, Instructions, Notes and, when present, Name) from the
// View Job panel. The same text the Price List edits, saved the same way: the job-level jobDetails object, with the
// other public fields hydrated from the intake answers exactly as Price List would on open, and the selected
// estimate's snapshot kept in step. Private notes never pass through here; Parts and any other stored keys are kept.
export const EDITABLE_JOB_DETAIL_FIELDS = ["name", "description", "instructions", "notes"];
const DEFAULT_JOB_DETAILS = { name: "", description: "", instructions: "", notes: "", parts: "" };

// Same gate as "Edit in Price List": Converge Custom administrators only.
export function canEditJobDetailsInline(orgId, { administrator = false } = {}) {
	return orgId === JAB_ORG_ID && administrator === true;
}

export function buildJobDetailsFieldUpdate(latest, field, value) {
	if (!latest || typeof latest !== "object" || Array.isArray(latest)) {
		throw new Error("The job could not be loaded.");
	}
	if (!EDITABLE_JOB_DETAIL_FIELDS.includes(field)) {
		throw new Error("That job detail cannot be edited here.");
	}
	const text = typeof value === "string" ? value.replace(/\r\n/g, "\n").trim() : "";
	const existing = latest.jobDetails && typeof latest.jobDetails === "object" && !Array.isArray(latest.jobDetails) ? latest.jobDetails : {};
	const jobDetails = { ...DEFAULT_JOB_DETAILS, ...(computeJobDetails(latest) || existing), [field]: text };
	const checklist = { ...latest, jobDetails };
	if (Array.isArray(latest.estimates)) {
		checklist.estimates = mergeActiveEstimateSnapshot({
			estimates: latest.estimates,
			selectedValue: latest.selectedValue || "",
			invoiceItems: [],
			jobDetails
		});
	}
	return { checklist, jobDetails };
}
